import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { FUNDING_REQUEST_ERROR_REASONS } from "@academy-context/read/domain/types/admin/funding-request";

export const updateFundingRequestError = createApiThunk<
  void,
  { id: string; error: FUNDING_REQUEST_ERROR_REASONS; sendNotificationToStudent: boolean }
>("fundingRequests/updateFundingRequestError", async ({ id, error, sendNotificationToStudent }, { extra: { adminRepository } }) => {
  return adminRepository!.updateErrorReason(id, { error, sendNotificationToStudent });
});

export const resetUpdateFundingRequestError = createAction("fundingRequests/resetUpdateFundingRequestError");
